export default __webpack_public_path__ + "static/media/copy.41911d7a.svg";